import React from "react";
import { connect } from "react-redux";
import { Table } from "../Table";
import language from "../../language";

class ViewTestAssayRule extends React.Component {
  state = {
    isLoading: false,
    error: {},
    csvData: [],
  };

  returnTableHeaders() {
    return [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
      },
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
      },
      {
        title: language[this.props.defaultLanguage].disease,
        key: "disease",
      },
      {
        title: language[this.props.defaultLanguage].test_type,
        key: "testType",
        render: (val) => (val === "bloodGrouping" ? "Blood Grouping" : "Serology"),
      },
      {
        title: language[this.props.defaultLanguage].assay_role,
        key: "assayRole",
      },
      {
        title: language[this.props.defaultLanguage].stage,
        key: "stage",
      },
      {
        title: language[this.props.defaultLanguage].block_donor,
        key: "blockDonor",
        render: (val) => (val ? "Yes" : "No"),
      },
      {
        title: language[this.props.defaultLanguage].block_donation,
        key: "blockDonation",
        render: (val) => (val ? "Yes" : "No"),
      },
      {
        title: language[this.props.defaultLanguage].result_condition,
        key: "resultCondition",
        render: (val) => {
          if (!val && val !== 0) return "-";
          const s = typeof val === "object" ? (val.name || val.value || val.label || "") : String(val);
          if (!s) return "-";
          return s.charAt(0).toUpperCase() + s.slice(1).replace(/_/g, " ");
        },
      },
      {
        title: language[this.props.defaultLanguage].donation_status,
        key: "donationStatus",
        render: (val) => {
          if (!val) return "-";
          const s = typeof val === "object" ? (val.name || val.value || val.label || "") : String(val);
          return s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "-";
        },
      },
      {
        title: language[this.props.defaultLanguage].donor_status,
        key: "donorStatus",
        render: (val) => {
          if (!val) return "-";
          const s = typeof val === "object" ? (val.name || val.value || val.label || "") : String(val);
          return s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "-";
        },
      },
      {
        title: language[this.props.defaultLanguage].action_required,
        key: "actionRequired",
        render: (val) => val || "-",
      },
      {
        title: language[this.props.defaultLanguage].block_classification,
        key: "blockClassification",
        render: (val) => {
          if (!val) return "-";
          const s = typeof val === "object" ? (val.name || val.value || val.label || "") : String(val);
          return s ? s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "-";
        },
      },
      {
        title: language[this.props.defaultLanguage].next_actions,
        key: "nextActions",
        render: (val) => (Array.isArray(val) ? val.join(", ") : val || "-"),
      },
      {
        title: language[this.props.defaultLanguage].mandatory_actions,
        key: "mandatoryActions",
        render: (val) => (val === true ? "Yes" : val === false ? "No" : "-"),
      },
      {
        title: language[this.props.defaultLanguage].blood_group_scenario,
        key: "bloodGroupScenario",
        render: (val) => val || "-",
      },
      {
        title: language[this.props.defaultLanguage].quarantine_donation,
        key: "quarantineDonation",
        render: (val) => (val === true ? "Yes" : val === false ? "No" : "-"),
      },
      {
        title: language[this.props.defaultLanguage].requires_investigation,
        key: "requiresInvestigation",
        render: (val) => (val === true ? "Yes" : val === false ? "No" : "-"),
      },
      {
        title: language[this.props.defaultLanguage].product_restrictions,
        key: "productRestrictions",
        render: (val) => (val ? (typeof val === "object" ? JSON.stringify(val) : val) : "-"),
      },
      {
        title: language[this.props.defaultLanguage].is_active,
        key: "isActive",
        render: (val) => (val ? "Active" : "Inactive"),
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
    ];
  }

  render() {
    return (
      <div className="card-body">
        <Table
          data={[this.props.data]}
          isLoading={this.state.isLoading}
          headers={this.returnTableHeaders()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(ViewTestAssayRule);
